import React from 'react';
import BarSplitChart from './BarSplitChart';
import { getCountryName } from '../../../utils/countries';

// India is excluded by business decision; codes become display names.
const excludeIndiaAndName = (rows) =>
  rows
    .filter((r) => String(r.name || '').trim().toUpperCase() !== 'IN')
    .map((r) => ({ ...r, name: getCountryName(String(r.name || '').trim()) || r.name }));

const CountrySplitChart = () => (
  <BarSplitChart
    title="Split Over Country"
    endpoint="/dashboard/country-split"
    cornerLabel="descending"
    barColor="var(--dash-chart-3)"
    maxRows={7}
    transform={excludeIndiaAndName}
  />
);

export default CountrySplitChart;
